export const admin = {
  namespaced: true,
  state: {
    salesRepresentatives: []
  },
  getters: {
    salesRepresentatives: state => state.salesRepresentatives
  },
  actions: {
  },
  mutations: {
    ADD_SALES_REPRESENTATIVE (state, defaultTitleId) {
      state.salesRepresentatives.push(
        {
          id: 0,
          firstName: null,
          lastName: null,
          hasLogin: false,
          username: null,
          email: null,
          password: null,
          requiresPasswordOnSubmit: false,
          isEnabled: false,
          isLockout: false,
          receivesInvoices: false,
          receivesReports: false,
          receivesReportsOnly: false,
          receivesChatReports: false,
          isAstechUser: false,
          titleId: defaultTitleId,
          phone: null
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/index.js